import { render, staticRenderFns } from "./Investor.vue?vue&type=template&id=767b7e55&scoped=true&"
import script from "./Investor.vue?vue&type=script&lang=js&"
export * from "./Investor.vue?vue&type=script&lang=js&"
import style0 from "./Investor.vue?vue&type=style&index=0&id=767b7e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b7e55",
  null
  
)

export default component.exports